module.exports = __webpack_public_path__ + "img/program-modify.88171e01.jpg";